import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IDrawsState } from ".";

export enum WinReason {
    None = 0,
    Draw = 1,
    CollectionComplete = 2,
    FragmentsComplete = 3,
}

export interface IWinnerData {
    name: string,
    username: string,
    userId: number,
    wins: {
        date: number;
        value: number;
        reason: WinReason;
    }[],
}

export interface IPagination {
    currentPage: number,
    totalPages: number,
    totalItems: number,
    itemsPerPage: number,
    hasNextPage: boolean,
    hasPreviousPage: boolean,
}

export interface IDrawsWinners {
    data: IWinnerData[],
    pagination: IPagination | null;
};

export interface IGetWinnersResponse extends IDrawsWinners{};

export const getDrawsWinners = createAsyncThunk<IGetWinnersResponse, number>(
    'draws/getWinners',
    async (page: number) => await api.draws.getWinners(page)
);

const getDrawsWinnersHandler = (builder: ActionReducerMapBuilder<IDrawsState>) => {
    builder
        .addCase(getDrawsWinners.pending, (state: IDrawsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getDrawsWinners.fulfilled, (state: IDrawsState, action: PayloadAction<IGetWinnersResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.winners = action.payload;
        })
        .addCase(getDrawsWinners.rejected, (state: IDrawsState) => {
            state.loading = false;
            state.error = 'Unable to get draws winners';
        });
};

export default getDrawsWinnersHandler;